
import { defineComponent, PropType } from "vue";
import { Quiz } from "@/pages/Quiz.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default defineComponent({
  name: "Select",
  components: {
    FontAwesomeIcon,
  },
  props: {
    modelValue: String,
    id: String,
    label: String,
    placeholder: String,
    selectOptions: Array as PropType<Quiz[]>,
    validationError: {
      type: [String, Boolean],
      validator(value: "valid" | "invalid" | false) {
        return ["valid", "invalid", false].includes(value);
      },
    },
  },
  emits: ["update:modelValue"],
  computed: {
    getValidationClass() {
      if (this.validationError === false) {
        return "";
      }
      return this.validationError === "invalid"
        ? "form__input--invalid"
        : "form__input--valid";
    },
  },
});
